import {take, call, put, select} from 'redux-saga/effects'
import {message} from 'antd'
import device from '../api/device'
import events from '../api/events'
import {putNotify} from './utils'
import {b64DecodeUnicode} from '../utils'
import {
  //SET_STATION,
  FETCH_PRESENTATION_STATION_REQUEST,
  FETCH_PRESENTATION_STATION_SUCCESS,
  FETCH_PRESENTATION_STATION_FAILURE,
  SENDING_DEVICE_STATUS_REQUEST,
  //FETCH_DEVICE_STATUS_REQUEST,
  //FECTH_DEVICE_STATUS_SUCCESS,
  FECTH_DEVICE_STATUS_FAILURE,
  MQTT_DEVICE_STATUS_RECEIVED,
  MQTT_NEW_EVENT_RECEIVED,
  //MQTT_NEW_CONFIG_RECEIVED,
  DEVICE_STATUS_UPDATED,
  NEW_EVENTS_UPDATED,
  SENDING_STATION_CONFIG_REQUEST,
  //FETCH_STATION_CONFIG_REQUEST,
  //FECTH_STATION_CONFIG_SUCCESS,
  FECTH_STATION_CONFIG_FAILURE,
  SENDING_RECENT_EVENT_REQUEST,
  //FETCH_RECENT_EVENT_REQUEST,
  FECTH_RECENT_EVENT_SUCCESS,
  FECTH_RECENT_EVENT_FAILURE,
  SENDING_DEVICE_COMMAND_REQUEST,
  POST_DEVICE_COMMAND_REQUEST,
  POST_DEVICE_COMMAND_SUCCESS,
  POST_DEVICE_COMMAND_FAILURE,
  SENDING_REBOOT_REQUEST,
  POST_REBOOT_REQUEST,
  POST_REBOOT_FAILURE,
  SENDING_SYNC_REQUEST,
  POST_SYNC_REQUEST,
  POST_SYNC_FAILURE
} from '../actions/constants'

import {CONFIG_CATEGORY_SCRIPT, CONFIG_CATEGORY_BIN} from '../constants/defaultValues'

const getTokenFromState = (state) => state.user.currentUser.token;
const getSystemIDFromState = (state) => state.system.currentSystem.ID;
const getStationIDFromState = (state) => state.station.currentStation.ID;
const getDevicesFromState = (state) => [...state.device.devices]
const getEventsFromState = (state) => [...state.device.events]
const getScriptsFromState = (state) => [...state.device.scripts]
const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

function* deviceStatusRequest({token, systemID, stationID}) {
  yield put({type: SENDING_DEVICE_STATUS_REQUEST, sending: true})
  try {
    return yield call(device.fetchDeviceStatus, token, systemID, stationID)
  } catch (error) {
    yield put({type: FECTH_DEVICE_STATUS_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_DEVICE_STATUS_REQUEST, sending: false})
  }
}

function* stationConfigRequest({token, systemID, stationID}) {
  yield put({type: SENDING_STATION_CONFIG_REQUEST, sending: true})
  try {
    return yield call(device.fetchStationConfig, token, systemID, stationID)
  } catch (error) {
    yield put({type: FECTH_STATION_CONFIG_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_STATION_CONFIG_REQUEST, sending: false})
  }
}

export function* watchStationPresentationRequest() {
  while (true) {
    yield take(FETCH_PRESENTATION_STATION_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const stationID = yield select(getStationIDFromState);
    const response = yield call(stationConfigRequest, {token, systemID, stationID})
    const arr = yield call(putNotify, {response})
    const stationConfigs = Array.isArray(arr)
      ? arr
      : []
    const stationConfigBin = stationConfigs.find((config) => {
      return config.Category === CONFIG_CATEGORY_BIN
    })
    const stationConfigScripts = stationConfigs.filter((config) => {
      return config.Category === CONFIG_CATEGORY_SCRIPT
    })
    //console.log(stationConfigs);
    //console.log(stationConfigBin);
    try {
      const scripts = stationConfigScripts.map((config) => {
        const jConfigScript = JSON.parse(b64DecodeUnicode(config.Data))
        return {
          ...jConfigScript,
          ScriptId: config.CategoryID
        }
      })
      const eventDisconnected = [
        {
          ScriptId: 255,
          Name: "Mất kết nối",
          AlarmLevel: 1
        }
      ]
      const fullScripts = scripts.concat(eventDisconnected)
      const jConfigBin = JSON.parse(b64DecodeUnicode(stationConfigBin.Data))
      //console.log(jConfigBin);
      const deviceMap = yield call(deviceStatusRequest, {token, systemID, stationID})
      //console.log(JSON.stringify(jConfigBin.Devices));
      const rawDevices = jConfigBin.Devices.map((dev) => {
        const devId = Object.keys(deviceMap).find((key) => {
          return parseInt(key, 10) === dev.DeviceId
        })
        const value = deviceMap[devId];
        const jDevice = JSON.parse(atob(value.Data))
        return {
          ...dev,
          State: jDevice.State,
          Val: jDevice.Val,
          Time: jDevice.Time
        }
      })
      const rooms = [...jConfigBin.Rooms]
      //console.log(JSON.stringify(rooms));
      const cameras = jConfigBin.Cameras
        ? [...jConfigBin.Cameras]
        : []
      //console.log(JSON.stringify(cameras));
      const reduceDevices = yield call(device.reduceRoomDevices, {rawDevices, rooms})
      const stateDevices = yield call(device.reduceStateDevices, {reduceDevices})
      stateDevices.sort((a, b) => {
        return a.Index - b.Index
      })
      yield put({type: FETCH_PRESENTATION_STATION_SUCCESS, devices: stateDevices, rooms: rooms, scripts: fullScripts, cameras: cameras});
    } catch (error) {
      yield put({type: FETCH_PRESENTATION_STATION_FAILURE, error: error.message})
    }
  }
}

export function* watchDeviceStatusUpdated() {
  while (true) {
    const {newDeviceStatusState} = yield take(MQTT_DEVICE_STATUS_RECEIVED)
    const devices = yield select(getDevicesFromState)

    const reduceDevices = devices.map((dev) => {
      const status = newDeviceStatusState.find((status) => {
        return status.ID === dev.DeviceId
      })
      if (status) {
        const jDevice = JSON.parse(atob(status.Data))
        return {
          ...dev,
          State: jDevice.State,
          Val: jDevice.Val,
          Time: jDevice.Time
        }
      } else {
        return {
          ...dev
        }
      }
    })
    const stateDevices = yield call(device.reduceStateDevices, {reduceDevices})
    yield put({type: DEVICE_STATUS_UPDATED, devices: stateDevices});
  }
}

export function* watchNewEventsUpdated() {
  while (true) {
    const {newEventsState} = yield take(MQTT_NEW_EVENT_RECEIVED)
    const filterAlarmLevel = newEventsState.filter((ev) => {
      return ev.AlarmLevel > 0
    })
    const events = yield select(getEventsFromState)
    const mergeEvents = events.concat(filterAlarmLevel)
    mergeEvents.sort((a, b) => {
      const t1 = b.Time || b.StartTime
      const t2 = a.Time || a.StartTime
      return t1 - t2
    })
    yield put({type: NEW_EVENTS_UPDATED, events: mergeEvents});
  }
}

function* recentEventRequest({token, systemID, stationID}) {
  yield put({type: SENDING_RECENT_EVENT_REQUEST, sending: true})
  try {
    return yield call(events.fetchRecentEvents, token, systemID, stationID)
  } catch (error) {
    yield put({type: FECTH_RECENT_EVENT_FAILURE, error: error.message})
  } finally {
    yield put({type: SENDING_RECENT_EVENT_REQUEST, sending: false})
  }
}

export function* watchRecentEvents() {
  while (true) {
    yield take(FETCH_PRESENTATION_STATION_SUCCESS)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const stationID = yield select(getStationIDFromState);
    try {
      const response = yield call(recentEventRequest, {token, systemID, stationID})
      const arr = yield call(putNotify, {response})
      const events = arr
        ? arr
        : []
      const scripts = yield select(getScriptsFromState)
      const filterEvents = events.filter((ev) => {
        const index = scripts.findIndex((sc) => {
          return sc.ScriptId === ev.EventID
        })
        return index > -1
          ? true
          : false
      })
      const filterAlarmLevel = filterEvents.filter((ev) => {
        return ev.AlarmLevel > 0
      })
      filterAlarmLevel.sort((a, b) => {
        return b.StartTime - a.StartTime
      })
      yield put({type: FECTH_RECENT_EVENT_SUCCESS, events: filterAlarmLevel});
    } catch (error) {
      yield put({type: FECTH_RECENT_EVENT_FAILURE, error: error.message})
    }
  }
}

function* deviceCommandRequest({token, systemID, newCommandState}) {
  yield put({type: SENDING_DEVICE_COMMAND_REQUEST, sending: true})
  try {
    return yield call(device.postDeviceCommand, token, systemID, newCommandState)
  } catch (error) {
    yield put({type: POST_DEVICE_COMMAND_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_DEVICE_COMMAND_REQUEST, sending: false})
  }
}

export function* watchDeviceCommand() {
  while (true) {
    const {newCommandState} = yield take(POST_DEVICE_COMMAND_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(deviceCommandRequest, {token, systemID, newCommandState})
    const result = yield call(putNotify, {response})
    if (result && result.error) {
      message.error(result.error)
    }
    yield put({type: POST_DEVICE_COMMAND_SUCCESS});
  }
}

function* rebootRequest({token, systemID, newRebootState}) {
  yield put({type: SENDING_REBOOT_REQUEST, sending: true})
  try {
    return yield call(device.postReboot, token, systemID, newRebootState)
  } catch (error) {
    yield put({type: POST_REBOOT_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_REBOOT_REQUEST, sending: false})
  }
}

export function* watchReboot() {
  while (true) {
    const {newRebootState} = yield take(POST_REBOOT_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(rebootRequest, {token, systemID, newRebootState})
    const notify = "Gửi lệnh reboot liệu thành công!"
    const result = yield call(putNotify, {response, notify})
    if (result && result.error) {
      message.error(result.error)
    } else {
      yield call(putNotify, {response, notify})
      yield call(delay, 10000);
      yield put({type: FETCH_PRESENTATION_STATION_REQUEST});
    }
  }
}

function* syncRequest({token, systemID, newSyncReqState}) {
  yield put({type: SENDING_SYNC_REQUEST, sending: true})
  try {
    return yield call(device.postSyncReq, token, systemID, newSyncReqState)
  } catch (error) {
    yield put({type: POST_SYNC_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_SYNC_REQUEST, sending: false})
  }
}

export function* watchSyncReq() {
  while (true) {
    const {newSyncReqState} = yield take(POST_SYNC_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(syncRequest, {token, systemID, newSyncReqState})
    const notify = "Gửi lệnh đồng bộ dữ liệu thành công!"
    const result = yield call(putNotify, {response, notify})
    if (result && result.error) {
      message.error(result.error)
    } else {
      yield call(delay, 10000);
      yield put({type: FETCH_PRESENTATION_STATION_REQUEST});
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/station.js